<p class="p-sm text-gray-500">
	Edits to this package will also be applied to the corresponding documents:
</p>
<ul class="py-3 space-y-1 list-disc list-inside">
	<ng-container *ngFor="let doc of data.wordDocuments; trackBy: trackByContent">
		<li class="p-sm">
			{{ doc.document.title || 'Untitled Document' }}
		</li>
	</ng-container>
</ul>

<ui-checkbox
	[(ngModel)]="dontShowAgain"
	label="Please don't show me this again"
></ui-checkbox>
